import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogComposerAttachmentsImage from '../VeltCommentDialogComposerAttachmentsImage/VeltCommentDialogComposerAttachmentsImage';
import VeltCommentDialogComposerAttachmentsOther from '../VeltCommentDialogComposerAttachmentsOther/VeltCommentDialogComposerAttachmentsOther';
import { transformWireframeProps } from '../../../../../utils/propUtils';
;
var VeltCommentDialogComposerAttachmentsSelected = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-selected-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogComposerAttachmentsSelected.Image = VeltCommentDialogComposerAttachmentsImage;
VeltCommentDialogComposerAttachmentsSelected.Other = VeltCommentDialogComposerAttachmentsOther;
export default VeltCommentDialogComposerAttachmentsSelected;
